/**
 * 三包登记的新增页面 货品配置处理
 * @author zjs
 * @time 2017-09-18
 */
export default {
    data () {
        return {
            productConfig: [{
                prop: 'product',
                label: '货品编码',
                width: 110,
                json: {
                    size: 'small',
                    api: 'api/product',
                    prop: 'product_cai'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'product',
                label: '货品名称',
                width: 286,
                json: {
                    size: 'small',
                    api: 'api/product',
                    prop: 'product_name'
                },
                component: 'LyAutoProduct'
            }, {
                prop: 'taihao',
                label: '胎号/DOT号',
                width: 140,
                json: {
                    width: '856px',
                    api: 'api/taihaolist',
                    size: 'small',
                    prop: 'taihao_no',
                    fields: [{
                        "label":"货品编码",
                        "prop":"product_cai",
                        width: 100
                    },{
                        "label":"货品名称",
                        "prop":"product_name",
                        width: 285
                    },{
                        "label":"胎号",
                        "prop":"taihao_no",
                        width: 140
                    },{
                        "label":"销售时间",
                        "prop":"xiaoshou_time",
                        width: 90
                    },{
                        "label":"销售客户名称",
                        "prop":"xiaoshou_customer",
                        width: 240
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'taihao',
                label: '销售时间',
                width: 130,
                json: {
                    isToday: false,
                    type: 'date',
                    prop: 'xiaoshou_time'
                },
                component: 'LyDatePicker'
            }, {
                prop: 'taihao',
                label: '实际销售客户',
                width: 220,
                json: {
                     width: '856px',
                    api: 'api/taihaolist',
                    size: 'small',
                    prop: 'xiaoshou_customer',
                    fields: [{
                        "label":"货品编码",
                        "prop":"product_cai",
                        width: 100
                    },{
                        "label":"货品名称",
                        "prop":"product_name",
                        width: 285
                    },{
                        "label":"胎号",
                        "prop":"taihao_no",
                        width: 140
                    },{
                        "label":"销售时间",
                        "prop":"xiaoshou_time",
                        width: 90
                    },{
                        "label":"销售客户名称",
                        "prop":"xiaoshou_customer",
                        width: 240
                    }]
                },
                component: 'LyAutoSearch'
            }, {
                prop: 'guowang_price',
                label: '过往售价',
                width: 90,
                component: 'LyInputNumber'
            }, {
                prop: 'zibianhao',
                label: '自编号',
                width: 80,
                component: 'ElInput'
            }, {
                prop: 'symptom',
                label: '病象名称',
                width: 110,
                json: {
                    api: 'api/bingxiang',
                    width: '300px',
                    size: 'small',
                    prop: 'bingxiang_name',
                    fields: [{
                        label: '病象',
                        prop: 'bingxiang_name'
                    },{
                        label: '病象分类',
                        prop: 'bingxiang_type'
                    }]
                },
                component: 'LyAutoSearch'
            }, 
            {
                prop: 'symptom',
                label: '病象分类',
                width: 60,
                json: {
                    prop: 'bingxiang_type'
                },
                component: 'text'
            }, 
            {
                prop: 'yuhua',
                label: '余花',
                width: 100,
                component: 'ElInput'
            }, {
                prop: 'comment',
                label: '备注',
                width: 150,
                component: 'ElInput'
            }]
        }
    }
}